import {Experience} from '@wix/ambassador-table-reservations-v1-experience/types'

export const sortExperiencesAlphabetically = (experiences: Experience[]): Experience[] =>
  [...experiences].sort((a, b) => {
    const nameA = a.configuration?.displayInfo?.name ?? ''
    const nameB = b.configuration?.displayInfo?.name ?? ''
    return nameA.localeCompare(nameB)
  })

export const sortExperiencesManually = (
  experiences: Experience[],
  manualOrder?: string[],
): Experience[] => {
  if (!manualOrder) {
    return experiences
  }

  const orderMap = new Map(manualOrder.map((id, index) => [id, index]))
  return [...experiences].sort((a, b) => {
    const indexA = orderMap.get(a.id!) ?? Number.MAX_SAFE_INTEGER
    const indexB = orderMap.get(b.id!) ?? Number.MAX_SAFE_INTEGER
    return indexA - indexB
  })
}
